import React, { useEffect } from 'react'
import Style from './successfull.module.scss'
import Logo from '../../../../assets/theme6/quizwall.png'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import SuccesssAnimation from '../Animation/successAnimation'
import SuccessImg from '../../../../assets/theme6/failed.svg'
import Successfull from './Successfull'
import Unsuccessfull from './Unsuccessfull'



const CardResult = () => {
  const { id } = useParams();


  const search = useLocation().search;
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // Optional: smooth scrolling animation
  });

  const navigate = useNavigate()

  const navigateHanler = () => {
      navigate('/home-challenge')
  }

  useEffect(() => {

    window.location.hash = window.location.hash + "no-back-button";
    window.location.hash = "Again-No-back-button";
    window.onhashchange = function () {
      window.location.hash = "no-back-button";

    }

  }, [])
  return (
    <>
  {id == "success" ? <Successfull /> : <Unsuccessfull />}
    </>
  )
}

export default CardResult